import call from './call';
import {GET_LOG_OPERATIONS} from "../types";

export default (form) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
            dispatch({type: GET_LOG_OPERATIONS, payload: {logOperations: result[1].results, total:result[1].total, kind:'users'}});
    };
    dispatch(call("SystemService/getAllLogOperations",form,onResult));
};